import { render, staticRenderFns } from "./inboundShipments.vue?vue&type=template&id=0d9355e2"
import script from "./inboundShipments.vue?vue&type=script&lang=js"
export * from "./inboundShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports